import { CommonService } from './../../../services/common/common.service';
// Library Class
import { Component, OnInit, ViewChild, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import * as $ from 'jquery';
// Service Class
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';

// Class
import { CPPItemsFilter } from './../../../models/CPP/CPPItemsFilter';
import { CPPOrderSummaryVM } from './../../../models/CPP/CPPOrderSummaryVM';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { ToastrService } from 'ngx-toastr';
import { MasterConstants } from './../../../common/constants/master-constants';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { MobilePDFVM } from '../../../models/CPP/MobilePDFVM';
import { BlanketOrderService } from '../../../services/blanket-order/blanket-order.service';
import { QuoteOrderService } from '../../../services/quote-order/quote-order.service';
import { Subscription } from 'rxjs';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-blanket-order-summary',
  templateUrl: './blanket-order-summary.component.html',
  styleUrls: ['./blanket-order-summary.component.scss']
})
export class BlanketOrderSummaryComponent implements OnInit, OnDestroy, AfterViewInit {
  private subscription = new Array<Subscription>();
  isInstructionType = false;
  configurationMessage: any[];
  errorData: any[];
  ifAnyError: boolean = false;
  statusNotice = "";
  deliveryDate: Date;
  webOrderNumber = "";
  isBulkItemAvailable: boolean = false;
  bulkContactName = "";
  bulkContactNumber = "";
  isPackagedItemAvailable: boolean = false;
  packagedContactName = "";
  packagedContactNumber = "";
  packagedDeliveryInst = "";
  splitId: number;
  showErrorItems: boolean;
  showPDFIcon: boolean;
  totalOrderCost = 0;
  totalNumbersOfOrder = 0;
  totalnumbersOfProduct = 0;
  orderStatus = '';
  filter: any = new CPPItemsFilter();
  cppProductItemsDataSource: any[];
  shipToAccountdetails: any = {};
  soldToAccountdetails: any = {};
  deliverToAccountdetails: any = {};
  ascAccountDetails: any = {};
  dsmAccountDetails: any = {};
  statusNoticeData: any = {};
  orderPdf: CPPOrderSummaryVM = new CPPOrderSummaryVM();
  showBackToCppLanding: boolean;
  pdfDataObject: any;
  monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  jdeorderNumber = '';
  customerPONumber = '';
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  @ViewChild('contractsPaginator', { read: MatPaginator }) contractsPaginator: MatPaginator;
  isRedirectedFromPlacedOrder = false;
  readOnlyAccess = false;
  filter2: MobilePDFVM = new MobilePDFVM();
  basePdfData: string;
  eAAccountList: any[] = [];
  plAccess = false;
  disclaimerMessage: string;

  constructor(private router: Router,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private blanketOrderService: BlanketOrderService,
    private quoteService: QuoteOrderService,
    private commonService: CommonService) { }

  ngOnInit() {
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';
    this.loaderService.setLoaderStatus(true);
    const summaryScreenFrom = this.blanketOrderService.redirectFrom;
    if (summaryScreenFrom === 'placeOrder') {
      this.isRedirectedFromPlacedOrder = true;
      this.blanketOrderService.setRedirectionFrom('');
    }
    if (this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE)) {
      this.configurationMessage = JSON.parse(this.localStorageService.get(MasterConstants.CPP_ERROR_CONFIG_MESSAGE));
    }
    if (this.blanketOrderService.webOrderNumber) {
      var data = this.blanketOrderService.webOrderNumber.split('~');
      this.webOrderNumber = data[0];
      this.showErrorItems = data[1] === 'error' ? true : false;
      this.showPDFIcon = this.showErrorItems;
      this.showBackToCppLanding = data[2] === 'CPPLanding' ? true : false;
      this.getOrderSummaryData();
    } else {
      this.router.navigate(['/cpp/landing-data']);
      this.commonService.currentTabIndex.next(0);
    }

    this.statusNoticeData.withoutSplitNoticeStatus = this.configurationMessage.filter(x => x.id === 'ORDER_STATUS');
    this.statusNoticeData.splitNoticeStatus = this.configurationMessage.filter(x => x.id === 'ORDER_SPLIT_STATUS');
    this.statusNoticeData.errorNoticeStatus = this.configurationMessage.filter(x => x.id === 'ORDER_ERROR_STATUS');
    this.statusNoticeData.partialSplitStatus = this.configurationMessage.filter(x => x.id === 'PARTIAL_SPLIT');

    this.getShipToFacility();

    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.EARLY_ADVANTAGE_ORDER);
    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
  }

  // get account list for early advantage
  getShipToFacility() {
    this.subscription.push(this.blanketOrderService.blanketShipToList().subscribe(result => {
      this.eAAccountList = result;
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  getErrorMessagesForProduct(item) {
    let message = '';
    const configMessage = this.configurationMessage.filter(x => x.id === 'SPLIT_ERROR');
    if (configMessage && configMessage.length > 0) {
      message = configMessage[0].value;
    }
    return message;
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // set account table height
  setAccSummaryTableHeight() {
    const tableHeight = window.innerHeight - 65;
    $('.prepayContractOuter').css('height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  // get Order Summary Data for display and PDF
  getOrderSummaryData() {
    this.subscription.push(this.blanketOrderService.getOrderSummaryDetails(this.webOrderNumber).subscribe((result: CPPOrderSummaryVM) => {
      this.pdfDataObject = result;
      if (this.pdfDataObject.splitDetails[0].productDetail.some(x => x.bulkPackaged == 'bulk' || x.bulkPackaged == 'BULK')) {
        this.bulkContactName = this.pdfDataObject.bulkContactName;
        this.bulkContactNumber = this.pdfDataObject.bulkContactNumber;
        this.isBulkItemAvailable = true;
      }
      if (this.pdfDataObject.splitDetails[0].productDetail.some(x => x.bulkPackaged == "packaged" || x.bulkPackaged == "PACKAGED")) {
        this.packagedContactName = this.pdfDataObject.packagedContactName;
        this.packagedContactNumber = this.pdfDataObject.packagedContactNumber;
        this.packagedDeliveryInst = this.pdfDataObject.packagedDeliveryInst;
        this.isPackagedItemAvailable = true;
      }

      if (result && result.splitDetails && result.splitDetails.length > 0 && result.splitDetails.filter(x => x.splitId == 1).length > 0) {
        this.showPDFIcon = false;
      } else {
        this.showPDFIcon = true;
      }
      if (result && result.splitDetails && result.splitDetails.length > 0) {
        if (result.splitDetails.length == 1 && !result.splitDetails.find(e => e.splitId == 1)) {
          this.statusNotice = this.statusNoticeData.withoutSplitNoticeStatus[0].value;
        }
        else if (result.splitDetails.length > 1 && !result.splitDetails.find(e => e.splitId == 1)) {
          this.statusNotice = this.statusNoticeData.splitNoticeStatus[0].value;
        }
        else if (result.splitDetails.length > 1 && result.splitDetails.find(e => e.splitId == 1)) {
          this.statusNotice = this.statusNoticeData.partialSplitStatus[0].value;
        }
        if (this.showErrorItems) {
          this.cppProductItemsDataSource = result.splitDetails.filter(x => x.splitId == 1);
          if (this.cppProductItemsDataSource && this.cppProductItemsDataSource.length > 0) {
            this.totalNumbersOfOrder = this.cppProductItemsDataSource.length;
            this.cppProductItemsDataSource.forEach(x => {
              this.totalnumbersOfProduct += x.productDetail.length;
              x.originalOrderQuantity = x.originalOrderQuantity ? x.originalOrderQuantity.toFixed(this.commonService.countDecimals(x.originalOrderQuantity)) : x.originalOrderQuantity;
              x.productDetail.forEach(prod => {
                this.totalOrderCost += prod.totalPrice;
              });
            });
          }
          this.statusNotice = this.statusNoticeData.errorNoticeStatus[0].value;
        } else {
          this.cppProductItemsDataSource = result.splitDetails;
          if (this.cppProductItemsDataSource && this.cppProductItemsDataSource.length > 0) {
            this.totalNumbersOfOrder = this.cppProductItemsDataSource.length;
            this.cppProductItemsDataSource.forEach(x => {
              this.totalnumbersOfProduct += x.productDetail.length;
              x.originalOrderQuantity = x.originalOrderQuantity ? x.originalOrderQuantity.toFixed(this.commonService.countDecimals(x.originalOrderQuantity)) : x.originalOrderQuantity;
              x.productDetail.forEach(prod => {
                this.totalOrderCost += prod.totalPrice;
              });
            });
          }
          this.errorData = result.splitDetails.filter(x => x.splitId == 1);
          if (this.errorData && this.errorData.length > 0) {
            this.ifAnyError = true;
            if (this.errorData.length == result.splitDetails.length) {
              this.statusNotice = this.statusNoticeData.errorNoticeStatus[0].value;
            }
          }
        }

        this.webOrderNumber = result.webOrderNumber;
        this.orderStatus = result.orderStatus;
        this.deliveryDate = result.desiredDeliveryDate;
        this.shipToAccountdetails.AccountNumber = result.accountNumber;
        this.shipToAccountdetails.AccountName = result.accountName;
        this.shipToAccountdetails.Address1 = result.accountAddress1;
        this.shipToAccountdetails.Address2 = result.accountAddress2;
        this.shipToAccountdetails.AccountCity = result.accountCity;
        this.shipToAccountdetails.AccountState = result.accountState;
        this.shipToAccountdetails.AccountZipCode = result.accountZipCode;
        this.shipToAccountdetails.HeaderText = result.headerText;
        this.shipToAccountdetails.InstructionType = result.instructionType;
        this.shipToAccountdetails.CustomerPickUp = result.customerPickUp == 'N' ? 'NO' : 'YES';
        this.shipToAccountdetails.PlacedByName = result.placedByName;
        this.shipToAccountdetails.CreatedOn = result.createdOn;

        // this.deliverToAccountdetails
        if (result.deliverToDetail) {
          this.deliverToAccountdetails.AccountNumber = result.deliverToDetail.accountNo;
          this.deliverToAccountdetails.AccountName = result.deliverToDetail.accountName;
          this.deliverToAccountdetails.Address1 = result.deliverToDetail.address1;
          this.deliverToAccountdetails.AccountCity = result.deliverToDetail.city;
          this.deliverToAccountdetails.AccountState = result.deliverToDetail.state;
          this.deliverToAccountdetails.AccountZipCode = result.deliverToDetail.zipCode;
        }

        // this.soldToAccountdetails
        if (result.soldToDetail) {
          this.soldToAccountdetails.AccountNumber = result.soldToDetail.accountNo;
          this.soldToAccountdetails.AccountName = result.soldToDetail.accountName;
          this.soldToAccountdetails.Address1 = result.soldToDetail.address1;
          this.soldToAccountdetails.Address2 = result.soldToDetail.address2.replace('<br>', '');
          this.soldToAccountdetails.AccountCity = result.soldToDetail.city;
          this.soldToAccountdetails.AccountState = result.soldToDetail.state;
          this.soldToAccountdetails.AccountZipCode = result.soldToDetail.zipCode;
        }

        if (result.ascDetail) {
          this.ascAccountDetails.AccountName = result.ascDetail.ascName;
          this.ascAccountDetails.AscAddress1 = result.ascDetail.ascAddress1;
          this.ascAccountDetails.AscAddress2 = result.ascDetail.ascAddress2;
          this.ascAccountDetails.Phone = result.ascDetail.primaryPhone;
          this.ascAccountDetails.Email = result.ascDetail.emailAddress;
          this.ascAccountDetails.City = result.ascDetail.city;
          this.ascAccountDetails.State = result.ascDetail.state;
          this.ascAccountDetails.ZipCode = result.ascDetail.zipCode;
        }

        if (result.dsmDetail) {
          this.dsmAccountDetails.AccountName = result.dsmDetail.dsmAccountName;
          this.dsmAccountDetails.dsmAddress1 = result.dsmDetail.dsmAddress1;
          this.dsmAccountDetails.Phone = result.dsmDetail.primaryPhone;
          this.dsmAccountDetails.Email = result.dsmDetail.emailAddress;
          this.dsmAccountDetails.City = result.dsmDetail.city;
          this.dsmAccountDetails.State = result.dsmDetail.state;
          this.dsmAccountDetails.ZipCode = result.dsmDetail.zipCode;
        }

        this.jdeorderNumber = result.jdeorderNumber;
        this.shipToAccountdetails.CustomerPONumber = result.custPONumber;
      }
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // Create a new Cpp order(navigate to new order screen)
  createNewEAOrder() {
    this.router.navigate(['/cpp/blanket-order-create']);
  }

  // Navigate  to CPP landing page
  backToLandingPage() {
    this.subscription.push(this.blanketOrderService.checkBlanketOrderTabAccess().subscribe(result => {
      const hasBlanketTabAccess = result;
      this.subscription.push(this.quoteService.checkQuoteOrderTabAccess().subscribe(result => {
        const hasQuoteTabAccess = result;
        if (hasBlanketTabAccess && !hasQuoteTabAccess) {
          this.router.navigate(['/cpp/landing-data']);
          this.commonService.currentTabIndex.next(2);
        } else if (hasBlanketTabAccess && hasQuoteTabAccess) {
          this.router.navigate(['/cpp/landing-data']);
          this.commonService.currentTabIndex.next(3);
        }
        else {
          this.router.navigate(['/cpp/landing-data']);
          this.commonService.currentTabIndex.next(0);
        }
      }));
    }));
  }

  ngOnDestroy() {
    this.blanketOrderService.webOrderNumber = undefined;
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // Generate Pdf report
  generatePdf() {
    if (this.pdfDataObject) {
      const documentDefinition = this.getDocumentDefinition();
      if (this.isMobile) {
        const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
        pdfDocGenerator.getBase64((data) => {
          this.basePdfData = data;
          this.filter2 = {
            MobilePDFBase64: this.basePdfData,
            FileName: 'EarlyAdvantageOrder_' + this.pdfDataObject.webOrderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf'
          };
          this.subscription.push(this.blanketOrderService.sendBaseDate(this.filter2).subscribe((result) => {
            window.location.assign(result.filePath);
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        });
      } else {
        pdfMake.createPdf(documentDefinition).download('EarlyAdvantageOrder_' + this.pdfDataObject.webOrderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
      }
    } else {
      this.toastrService.error('No data available for WebOrderNumber #' + this.pdfDataObject.webOrderNumber);
    }
  }

  // PDF document defination
  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, 'MM/dd/yyyy');
    const orderCreateDate = this.pdfDataObject.createdOnString;
    let displayWith = [];
    let columnList = [];
    let valueList = [];
    let bulkdetailsheader;

    // ShipTo Account available
    if (!this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['100%'];
      columnList = [{ text: 'SHIP TO: ', bold: true }];
      // columnList = [{ text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }];
      valueList = [
        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,
      ];
    }
    // ShipTo & DeliverTo  Account available
    else if (this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SHIP TO: ', bold: true }, { text: 'DELIVER TO: ', bold: true }];
      // columnList = [{ text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }, { text: 'DELIVER TO: ' + this.deliverToAccountdetails.AccountNumber, bold: true }];
      valueList = [

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,

        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',
      ];
    }
    // ShipTo & SoldTo Account available
    else if (!this.deliverToAccountdetails.AccountName && this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SOLD TO: ', bold: true }, { text: 'SHIP TO: ', bold: true }];
      // columnList = [{ text: 'SOLD TO: ' + this.soldToAccountdetails.AccountNumber, bold: true }, { text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,
      ];
    }
    // ShipTo, SoldTo & DeliverTo Account available
    else {
      displayWith = ['33%', '33%', '33%'];
      columnList = [{ text: 'SOLD TO: ', bold: true }, { text: 'SHIP TO: ', bold: true }, { text: 'DELIVER TO: ', bold: true }];
      // columnList = [{ text: 'SOLD TO: ' + this.soldToAccountdetails.AccountNumber, bold: true }, { text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }, { text: 'DELIVER TO: ' + this.deliverToAccountdetails.AccountNumber, bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,

        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',

      ];
    }

    if (this.isBulkItemAvailable && this.isPackagedItemAvailable) {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, "MM/dd/yyyy")],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
          ['BULK CONTACT NAME:', this.pdfDataObject.bulkContactName],
          ['BULK CONTACT PHONE NUMBER:', this.pdfDataObject.bulkContactNumber],
          ['CONTACT NAME:', this.pdfDataObject.packagedContactName],
          ['CONTACT PHONE NUMBER:', this.pdfDataObject.packagedContactNumber],
          ['DELIVERY INSTRUCTIONS:', this.pdfDataObject.packagedDeliveryInst],
        ]
      };
    }
    else if (this.isBulkItemAvailable) {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, "MM/dd/yyyy")],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
          ['BULK CONTACT NAME:', this.pdfDataObject.bulkContactName],
          ['BULK CONTACT PHONE NUMBER:', this.pdfDataObject.bulkContactNumber],
        ]
      };
    }
    else if (this.isPackagedItemAvailable) {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, "MM/dd/yyyy")],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
          ['CONTACT NAME:', this.pdfDataObject.packagedContactName],
          ['CONTACT PHONE NUMBER:', this.pdfDataObject.packagedContactNumber],
          ['DELIVERY INSTRUCTIONS:', this.pdfDataObject.packagedDeliveryInst],
        ]
      };
    }
    else {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, "MM/dd/yyyy")],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
          //['ACCOUNT NUMBER:', this.pdfDataObject.accountNumber],
        ]
      };
    }
    //pdf html
    var pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: currDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAlCAYAAACwE5ygAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjZjgzMmU0Yy1kODcyLTQ3YWQtYmU4NC1mMDc4YTMzYTMwNTgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDEwRjZDNEM3MzAxMTFFOUE0RkRDODkwMzhGMUZGM0QiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDEwRjZDNEI3MzAxMTFFOUE0RkRDODkwMzhGMUZGM0QiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpjZjgzMmU0Yy1kODcyLTQ3YWQtYmU4NC1mMDc4YTMzYTMwNTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Y2Y4MzJlNGMtZDg3Mi00N2FkLWJlODQtZjA3OGEzM2EzMDU4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+NCs+0wAACJ5JREFUeNrsW3lsFFUYf3u05bBUCwUULCglWokU5RARhQJRIeCBCigIMSEgiglWRMAjiMQjeP6l4oWAiHJIRDksp4CAUkWg4AHlaCl35VxaaLd+X/p72a/PmdnZ2nYh2S/5Zd++mfdm5n3392Y89bs9OF8pdaOqoJGEVaoyzSZ0JHgI3xKyjONjCKPRnkcYr6qf+hLeIZTiv8fhXB/hb0IfdQmTn7CV0B//exuMuYbwsPj/NGEioVj0DSS0QntHDd1nU0JaBOenqUucmDGvYbHjCQMI48TxWy3GXCsY0IjQHu09hBloTyJcQQigXUJIFdpWTviYkGsx/wuExoRCwuvoC4jjywiLoRlWxNp0HG2eZwLO/Y3wGfrvI2QSgg5rw/OcIEzGeTcQRqB/A2GOi/UdD6Eqt5i7DM+4RKxnS8Jwwh8eMmXcsZ7QBQdvI/yE9lTCWGPSUYQPhAa9jfaHhMcJXlxU0+WEk4TuhjZyX2e+CWP+cvHrRfsRwhdos/DMdSl4GYQtaOcQOqD9FeZxQ3EwoYMIX6Ivm3Cni7HBMGZXifvh+ZsQdhPW+nHgE8GYTmCMR9z8IkIDQjfCYMGYTmLy+UIaDhCaEU4LqQwYN5MEgWiL85XQPDahf9o8RD9Ckc2xddBOTbK9T7QLRXsFrukVAhEHFIn7Py3GFLhkKj/D9YQz8M/lQlsS4Tv9cAes3T1gsXZrxszAYsfhwd8ltIP5UTAH6WBMVzxEEG29mNlVMKXJEIJ0C8bZ0aOAFTFD90Z4D1nwszVJhRBoK1/IZrk1TOtzhDeUkBJW1U1o98DvleIY+4LNYsJ6WITm+L8kwht9C2ZSgfk/G6bDiUoRfJg4SzhfhUXjSHItnp/xCyS4OsnumXYRHhP/h+qGV3R+KtptwUWmPPweFscz4TNMM+aWzkBltZa1gUPV2udEb0LtTbAgHazCorWG5ncCOgizXhskI9kEGZUpYc5YihsSpggztg6/59DuimhD22/WppUR3owOZ9mBbiTcgkBgPXyPE/1j2Pv/S1OgMT4h3evCjDkX4TXKHI71s5rXbwxeDjWWJ88U7c/BGClRs6qwGOeNkDwXfsaNpNarZollJvxg9CUgePEi9Db9HwtvCpjoMcJgNrWHjPM5FbkKftmH52f/OsyIel+xYgzT94Z9PUZYLf4vIHxkjFlu8bB1jF/TbMYZ4TFryzahpZXU2shZ/BEsusdYHKvrL3URbMwy7mGggx86grBXPkOqEXna+d2vrRZLIU4/Jf6b5Zki4XMUcpDNDoyREuW1WSSFa7Y3wtA6NoyJi4AxXheMcauhXpfnN7Z5Biu6AMEebuaLOsGUlAp4UHMy1bIVHC0f3wmtMqU0A3F6AAkem8nLUJPjRcm3cfINMDYIP7JVmI50LM5uF9InFyYDv4V4Hv2MLYw8x4ri8YzHkSi3gakqd6ikBERS2xbrcMFCYIII7Y9YqroFY2J0kdTKJBd9kIYyG6nwQPp8yB1K0ZcgVD3gIH3xGFOC+WVfsXEfQRf+Q9+rF/dV7iDNeu4SjPHhvoMW8wZdaFONktfID/ajdJHhEObmwxdkicrvXvTno+5jRdMwbi9Mk/Zp3Pe7uJcFMFUaBbinfWgXCqzBmJvE9Q/A/B40cAjoIwqZBRZjDmHuPITvI6KtMS2wyEz1HaReL2qKmKOJOGcAbOoQY2xz5ChJ4rotRJ+W9DtQmXZDKSL6SY7QOSeFuU4yqhtdEJn1RmJc64w5aUQL4RKls6KCWmZEToMRaT1hMX+ZMB8nRFgeh/j+fiyePo/rc2Nw3mwkwn6YnNMWERdXoZ83rEFdLLJHRJFyT0nOG8TYq1EjTEXuxjncA9FgTHXQj5BijqBG4SFHu7yWZuwai0xfM4bLNsvC1KJ8uFaCMNfHlPMmnt28XGrKAZP6w5Tvqm0fIylYxflWIpPX0vgkpE4vsBPZOe1mot3Ixf0OwuLlAtuM3MuK7OY9qirv/fSKhsZIqSu2Of+4TdKn6WYV2hTbiL5XVUXF9mgtPVMA9+ARUdavVRQKnVtF1fnLhW5J2G5xfjubcofpg7h83lNVbEIxZRsVhZqk91TFVnkkdMym/24jiFkcDcZwnUa/eMH78ZNQ3DuKaI0rwVPF+TlhJI/NGu/QfVfLktcLQhBvPGciTDeXmRYaY4bAZNaFWSyH9mcataz90WDMQuQyYxH+vu8wjs3TN2IOnwiJzaLoUBV6SUM6Zx0uaxtvtzeeZBEemyTD+46AHWXgWRNFX2fAjrjq+1K0TBnTs5Coe5BPpBsFSzZJSw2V5pB1HmphVvsyM7EIvWHqLohQexaChYMq9M6YSduhdT5EfVbESeuiMHUsXTubh3Yu5j1vkfn7UMPaiSRzU237mHC1smQs6hnD8ccoynlMkbJ/IyVGUchjYnQRaUxTmC2fcMRsuyPd385EuD09jL2PkUsfk22R2XZRobdX3NJh1Lo8seWtHo3RL4b3FGFtHmpOJcaYBERWPuQnJ0VZ5Aiin/oYV2pERXovJlGF3naMkYOP0RtPKwHWoBNYdP1KLFdo85Gv3I5QuQi/D4nsv0CFXgzXr9G+qCrqZX7kBKcQ6a2KaZczY/KwQAEgB9LNjBiJc4bDFxUiweRMmN8k5M2l2TjnLLRhDxJCXRl+Cj6L+15WFS/88ftk3VXFazwxsmFMHeFrVoik6hmRXfNu3hZoSEOUbqajSqDNYrHI1rmQOQgmKwUJrC6W8h6H3hK4LsYKex+TClN2r3GOzrbnoHQyzCivKPXf14F0/wSYKv0JBb+qo79eS4CZHInsOkY2jNGfCMh3mCfD/LDk90XfGuFLshCFTRRlljQVql2thvNn/7MD2qR3R9nU8cuD/CHUgRgr7E0Zf7+xHT5DQ++Ps7Pmbz3mCgbcBR80DQGA/pBnkxFi87c3f4HJCqZwHEzcBghCWowVlelfAQYAh1IXcqAQJnwAAAAASUVORK5CYII=',
          width: 102,
          height: 37,
          alignment: 'left',
        },
        {
          layout: 'noBorders',
          table: bulkdetailsheader,
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'pageText',
          layout: 'noBorders',
        },

        this.getContractPdfObject(this.pdfDataObject.splitDetails),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis order was committed by ' + this.pdfDataObject.placedByName + ' on ' + orderCreateDate
                + '(CST). If you have any questions regarding these changes, please contact WinField United Customer Service, 1-855-494-6343. Shipments made at WinField® United\'s discretion.'],
            ]
          },
          layout: 'noBorders'
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#f5f4f2',
          fontSize: 8,
          color: '#0b3f54',
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
        tableUnit: {
          fontSize: 8,
          background: '#feeaa6',
          color: '#757575'
        },
        tablePayment: {
          fontSize: 8,
          background: '#b4e3df',
          color: '#757575'
        },
        itemFlashMsgDescBorder:
        {
          color: 'red'
        }
      }
    };

    return pdfHTML;
  }

  // Grid display for each split in PDF
  getContractPdfObject(splitDetails) {
    let tbl = {};
    const tblObject = [];
    let colum = [];
    const isRedirected: boolean = this.isRedirectedFromPlacedOrder;
    let itemFlashMsgDescCount = [];
    splitDetails.forEach(obj => {
      itemFlashMsgDescCount = obj.productDetail.filter((obj) => obj.itemFlashMsgDesc != null && obj.itemFlashMsgDesc != '');
    });
    const count = itemFlashMsgDescCount.length;
    if (count > 0) {
      splitDetails.forEach(obj => {
        const cppOrderDetails = obj.productDetail;
        let jdeNumber = '';
        if (obj.jdeorderNumber) {
          jdeNumber = obj.jdeorderNumber;
        }
        if (isRedirected) {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString() + '-' + obj.splitId.toString(),
            alignment: 'left',
          }];
        }
        else if (jdeNumber != '' && this.bulkContactName != '' && this.bulkContactNumber != '') {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString(),
            alignment: 'left',
            width: '35%'
          },
          {
            text: 'Status:' + obj.orderStatus.toString(),
            alignment: 'left',
            width: '35%',
          },
          {
            text: 'Sales Order #: ' + jdeNumber,
            alignment: 'left',
            width: '30%',
          },

          ];
        }
        else if (jdeNumber == '') {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString(),
            alignment: 'left',
          },
          {
            text: 'Status: ' + obj.orderStatus.toString(),
            alignment: 'left',
          }];
        }
        else {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString() + '-' + obj.splitId.toString(),
            alignment: 'left',
          },
          {
            text: 'Sales Order #: ' + jdeNumber,
            alignment: 'left',
          },
          {
            text: 'Status: ' + obj.orderStatus.toString(),
            alignment: 'left',
          }];
        }
        const tblHeader = [
          {
            style: 'pageText',
            widths: ['20%', '20%', '20%', '20%', '10%', '10%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: colum
          }
        ];

        tblObject.push(tblHeader);
        if (this.isBulkItemAvailable) {
          const tblwithbulk = {
            table: {
              widths: ['40%', '15%', '15%', '15%', '15%'],
              color: '#0b3f54',
              body: [
                [{
                  text: 'Product',
                  style: 'tableHeader'
                },
                {
                  text: '',
                  style: 'tableHeader'
                },
                {
                  text: 'Ordered Quantity',
                  style: 'tableHeader', alignment: 'center'
                },
                {
                  text: 'Ordering UOM',
                  style: 'tableHeader', alignment: 'center'
                },
                {
                  text: 'Package Size',
                  style: 'tableHeader', alignment: 'center'
                },
                {
                  text: 'BULK REQUESTED DATE',
                  style: 'tableHeader', alignment: 'center'
                },

                ],
                ...cppOrderDetails.map(cpp => {
                  var cellData = [],
                    cellData = this.cppModifiedCellData(cpp);
                  return [
                    {
                      text: cellData
                    },
                    {
                      text: cpp.itemFlashMsgDesc, alignment: 'center', style: 'itemFlashMsgDescBorder'
                    },
                    { text: cpp.lineStatus == 'CANCELLED' ? 'Cancelled' : cpp.originalOrderQuantity.toFixed(this.commonService.countDecimals(cpp.originalOrderQuantity)), alignment: 'center' },
                    { text: cpp.uom, alignment: 'center' },
                    { text: cpp.packageSize, alignment: 'center' },
                    { text: cpp.bulkPackaged.toLowerCase() != 'bulk' ? ' ' : new Date(cpp.desiredDeliveryDate).toLocaleDateString('en-US'), alignment: 'center' },
                  ];
                })
              ]
            },
            style: 'tablefont',
          };
          tbl = tblwithbulk;
        }
        else {
          const tblwithoutbulk = {
            table: {
              widths: ['40%', '15%', '15%', '15%', '15%'],
              color: '#0b3f54',
              body: [
                [{
                  text: 'Product',
                  style: 'tableHeader'
                },
                {
                  text: '',
                  style: 'tableHeader'
                },
                {
                  text: 'Ordered Quantity',
                  style: 'tableHeader', alignment: 'center'
                },
                {
                  text: 'Ordering UOM',
                  style: 'tableHeader', alignment: 'center'
                },
                {
                  text: 'Package Size',
                  style: 'tableHeader', alignment: 'center'
                }
                ],
                ...cppOrderDetails.map(cpp => {
                  var cellData = [],
                    cellData = this.cppModifiedCellData(cpp);
                  return [
                    {
                      text: cellData
                    },
                    {
                      text: cpp.itemFlashMsgDesc, alignment: 'center', style: 'itemFlashMsgDescBorder'
                    },
                    { text: cpp.lineStatus == 'CANCELLED' ? 'Cancelled' : cpp.originalOrderQuantity.toFixed(this.commonService.countDecimals(cpp.originalOrderQuantity)), alignment: 'center' },
                    { text: cpp.uom, alignment: 'center' },
                    { text: cpp.packageSize, alignment: 'center' },
                  ];
                })
              ]
            },
            style: 'tablefont',
          };
          tbl = tblwithoutbulk;
        }
        tblObject.push(tbl);
      });
    } else {
      splitDetails.forEach(obj => {
        const cppOrderDetails = obj.productDetail;
        let jdeNumber = '';
        if (obj.jdeorderNumber) {
          jdeNumber = obj.jdeorderNumber;
        }
        if (isRedirected) {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString() + '-' + obj.splitId.toString(),
            alignment: 'left',
          }];
        }
        else if (jdeNumber != '' && this.bulkContactName != '' && this.bulkContactNumber != '') {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString(),
            alignment: 'left',
            width: '35%'
          },
          {
            text: 'Status: ' + obj.orderStatus.toString(),
            alignment: 'left',
            width: '35%',
          },
          {
            text: 'Sales Order #: ' + jdeNumber,
            alignment: 'left',
            width: '30%',
          },
          ];
        }
        else if (jdeNumber == '') {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString(),
            alignment: 'left',
          },
          {
            text: 'Status: ' + obj.orderStatus.toString(),
            alignment: 'left',
          }];
        }
        else {
          colum = [{
            text: 'Order ID: ' + this.webOrderNumber.toString() + '-' + obj.splitId.toString(),
            alignment: 'left',
          },
          {
            text: 'Sales Order #: ' + jdeNumber,
            alignment: 'left',
          },
          {
            text: 'Status: ' + obj.orderStatus.toString(),
            alignment: 'left',
          }];
        }
        const tblHeader = [
          {
            style: 'pageText',
            widths: ['20%', '20%', '20%', '20%', '10%', '10%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: colum
          }
        ];

        tblObject.push(tblHeader);
        if (this.isBulkItemAvailable) {
          const tblwithbulk = {
            table: {
              widths: ['30%', '15%', '15%', '25%', '15%'],
              color: '#0b3f54',
              body: [
                [{
                  text: 'Product',
                  style: 'tableHeader'
                },
                {
                  text: 'Ordered Quantity',
                  style: 'tableHeader', alignment: 'center'
                },
                {
                  text: 'Ordering UOM',
                  style: 'tableHeader', alignment: 'center'
                },
                {
                  text: 'Package Size',
                  style: 'tableHeader', alignment: 'center'
                },
                {
                  text: 'BULK REQUESTED DATE',
                  style: 'tableHeader', alignment: 'center'
                },

                ],
                ...cppOrderDetails.map(cpp => {
                  var cellData = [],
                    cellData = this.cppModifiedCellData(cpp);
                  return [
                    {
                      text: cellData
                    },
                    { text: cpp.lineStatus == 'CANCELLED' ? 'Cancelled' : cpp.originalOrderQuantity.toFixed(this.commonService.countDecimals(cpp.originalOrderQuantity)), alignment: 'center' },
                    { text: cpp.uom, alignment: 'center' },
                    { text: cpp.packageSize, alignment: 'center' },
                    { text: cpp.bulkPackaged.toLowerCase() != 'bulk' ? ' ' : new Date(cpp.desiredDeliveryDate).toLocaleDateString('en-US'), alignment: 'center' },
                  ];
                })
              ]
            },
            style: 'tablefont',
          };
          tbl = tblwithbulk;
        }
        else {
          const tblwithoutbulk = {
            table: {
              widths: ['45%', '15%', '15%', '25%'],
              color: '#0b3f54',
              body: [
                [{
                  text: 'Product',
                  style: 'tableHeader'
                },
                {
                  text: 'Ordered Quantity',
                  style: 'tableHeader', alignment: 'center'
                },
                {
                  text: 'Ordering UOM',
                  style: 'tableHeader', alignment: 'center'
                },
                {
                  text: 'Package Size',
                  style: 'tableHeader', alignment: 'center'
                }
                ],
                ...cppOrderDetails.map(cpp => {
                  var cellData = [],
                    cellData = this.cppModifiedCellData(cpp);
                  return [
                    {
                      text: cellData
                    },
                    { text: cpp.lineStatus == 'CANCELLED' ? 'Cancelled' : cpp.originalOrderQuantity.toFixed(this.commonService.countDecimals(cpp.originalOrderQuantity)), alignment: 'center' },
                    { text: cpp.uom, alignment: 'center' },
                    { text: cpp.packageSize, alignment: 'center' },
                  ];
                })
              ]
            },
            style: 'tablefont',
          };
          tbl = tblwithoutbulk;
        }
        tblObject.push(tbl);
      });
    }

    return tblObject;
  }

  // For your price and payment Term in the cell with style
  cppModifiedCellData(cpp) {
    const tempArray = [];
    if (cpp.itemVendorName) {
      tempArray.push(cpp.itemVendorName + ' \n' + cpp.itemDescription + '\n');
    }
    else {
      tempArray.push('' + cpp.itemDescription + '\n');
    }
    return tempArray;
  }
}
